module.exports = __webpack_public_path__ + "img/depmap_svg_V102.c6c17fe3.svg";